import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/features/auth/AuthLayout';
import { LoginForm } from '@/features/auth/LoginForm';
import { meQueryOptions } from '@/features/auth/useSession';
import { useT } from '@/i18n/useT';

const LoginSearch = z.object({ redirect: z.string().optional() });

export const Route = createFileRoute('/login')({
  validateSearch: LoginSearch,
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions()).catch(() => null);
    if (me) throw redirect({ to: '/' });
  },
  component: LoginPage,
});

function LoginPage() {
  const t = useT();
  const { redirect: redirectTo } = Route.useSearch();
  return (
    <AuthLayout title={t('auth.login.title')} description={t('auth.login.subtitle')}>
      <LoginForm redirect={redirectTo} />
    </AuthLayout>
  );
}
